import { HandleEnterUpdateDelete } from 'flip-toolkit/lib/types'
import React from 'react'
import { Flipped, Flipper } from 'react-flip-toolkit'

import { Product } from '../../../../../../../lib/sanity-dispensaries/manage/featured-products'
import { ProductListEntry } from '../ProductListEntry'
import * as StyledShared from './styled'

export interface ProductListProps {
  products?: Product[]
  moveProductUp: (product: Product) => void
  moveProductDown: (product: Product) => void
  removeProduct: (product: Product) => void
}

const exitAndFlipThenEnter: HandleEnterUpdateDelete = ({
  hideEnteringElements,
  animateEnteringElements,
  animateExitingElements,
  animateFlippedElements,
}) => {
  hideEnteringElements()
  Promise.all([animateExitingElements(), animateFlippedElements()]).then(animateEnteringElements)
}

const FlippedProductListEntry = React.memo<{
  product: Product
  isSingleProduct: boolean
  productsCount: number
  index: number
  moveProductUp: (product: Product) => void
  moveProductDown: (product: Product) => void
  removeProduct: (product: Product) => void
}>(function FlippedProductListEntry({
  product,
  isSingleProduct,
  productsCount,
  index,
  moveProductUp,
  moveProductDown,
  removeProduct,
  ...rest
}) {
  const hideUp = isSingleProduct || index === 0
  const hideDown = isSingleProduct || index === productsCount - 1
  return (
    <ProductListEntry
      product={product}
      actions={{
        _tag: 'selected',
        onUp: hideUp ? undefined : moveProductUp,
        onDown: hideDown ? undefined : moveProductDown,
        onRemove: removeProduct,
      }}
      {...rest}
    />
  )
})

export const ProductList: React.FC<ProductListProps> = ({
  products,
  moveProductUp,
  moveProductDown,
  removeProduct,
}) => {
  const productsCount = products?.length ?? 0
  const isSingleProduct = productsCount === 1
  const flipKey = products?.map(({ sku }) => sku).join('-') ?? ''
  return (
    <Flipper
      flipKey={flipKey}
      staggerConfig={{ default: { speed: 0.5 } }}
      spring="veryGentle"
      handleEnterUpdateDelete={exitAndFlipThenEnter}
    >
      <StyledShared.ItemsContainer>
        {products &&
          products.map((product, index) => (
            <Flipped flipId={`product-list-entry-${product.sku}`} key={product.sku} stagger>
              <FlippedProductListEntry
                product={product}
                isSingleProduct={isSingleProduct}
                productsCount={productsCount}
                index={index}
                moveProductUp={moveProductUp}
                moveProductDown={moveProductDown}
                removeProduct={removeProduct}
              />
            </Flipped>
          ))}
      </StyledShared.ItemsContainer>
    </Flipper>
  )
}
